module.exports = __webpack_public_path__ + "static/media/Arrow-down-common-red.ecad10fa.svg";